export const EOnboardRoutes = {
  change: 'change/:link',
  activate: 'activate/:link',
  login: 'login',
  register: 'register',
  restore: 'restore',
};

export type TOnboardRoutes = keyof typeof EOnboardRoutes;

export * from './Onboard/Register';
export * from './Onboard/Login';
export * from './Onboard/ChangePassword';
export * from './Onboard/Activation';
